import { render, staticRenderFns } from "./Sidebar2.vue?vue&type=template&id=15bd2e6a&"
import script from "./Sidebar2.vue?vue&type=script&lang=js&"
export * from "./Sidebar2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports